import * as React from "react";

/**
 * Thin usage/quota bar with optional soft-cap and hard-cap markers.
 */
export interface MeterProps {
  /** 0–1 */
  value: number;
  tone?: "accent" | "now" | "success";
  label?: React.ReactNode;
  valueLabel?: React.ReactNode;
  /** Positions 0–1. kind "hard" draws the red ceiling marker */
  markers?: { at: number; kind?: "soft" | "hard" }[];
  className?: string;
}

export function Meter({ value = 0, tone = "accent", label, valueLabel, markers = [], className }: MeterProps): JSX.Element {
  return (
    <div className={["gk-meter", tone !== "accent" && "gk-meter--" + tone, className].filter(Boolean).join(" ")}>
      {(label || valueLabel) && (
        <div className="gk-meter__head">
          <span>{label}</span>
          <b>{valueLabel}</b>
        </div>
      )}
      <div className="gk-meter__track" role="meter" aria-valuemin={0} aria-valuemax={1} aria-valuenow={value}>
        <div className="gk-meter__fill" style={{ width: Math.min(1, value) * 100 + "%" }} />
        {markers.map((m, i) => (
          <span
            key={i}
            className={"gk-meter__marker" + (m.kind === "hard" ? " gk-meter__marker--hard" : "")}
            style={{ left: "calc(" + m.at * 100 + "% - 1px)" }}
          />
        ))}
      </div>
    </div>
  );
}
